import Cookies from 'js-cookie';

import { getApiRequestContext } from './apiContext';

const COOKIE_EXPIRES_DAYS = 30;

const getCookieDomain = (hostname: string): string => {
  const parts = hostname.split('.');
  const baseDomain = parts.length > 2 ? parts.slice(1).join('.') : hostname;

  return `.${baseDomain}`;
};

const parseCookieHeader = (header?: string): Record<string, string> => {
  if (!header) {
    return {};
  }

  return header.split(';').reduce<Record<string, string>>((acc, part) => {
    const trimmed = part.trim();
    const separatorIndex = trimmed.indexOf('=');

    if (separatorIndex < 1) {
      return acc;
    }

    const name = trimmed.slice(0, separatorIndex).trim();
    const value = trimmed.slice(separatorIndex + 1).trim();

    try {
      acc[name] = decodeURIComponent(value);
    } catch {
      acc[name] = value;
    }

    return acc;
  }, {});
};

export const getCookie = (name: string): string | undefined => {
  if (typeof window !== 'undefined') {
    return Cookies.get(name);
  }

  return parseCookieHeader(getApiRequestContext()?.cookie)[name];
};

export const setCookie = (name: string, value: string): void => {
  if (typeof window === 'undefined') {
    return;
  }

  const { hostname, protocol } = window.location;
  const isLocalhost = hostname === 'localhost';

  Cookies.set(name, value, {
    ...(isLocalhost ? {} : { domain: getCookieDomain(hostname) }),
    expires: COOKIE_EXPIRES_DAYS,
    path: '/',
    secure: protocol === 'https:',
    sameSite: 'lax',
  });
};
